import {inheritPrototype, isDef, getObjMaxValue, getObjMinValue} from '../util/util'
import echarts from 'echarts'
import Base from './base'
import constant from '../util/contant'

const defaultNum = constant.defaultNum

// 折线图和柱状图 混合
var BarAndLineShare = function (dataList, type) {
    Base.call(this)
    this.type = type
    if (dataList) {
        this.xList = isDef(dataList.xList) ? dataList.xList : []
        this.yList = isDef(dataList.yList) ? dataList.yList : []
        this.optionSet = isDef(dataList.optionSet) ? dataList.optionSet : {}
    } else {
        this.xList = []
        this.yList = []
        this.optionSet = {}
    }

    this.init()
}
inheritPrototype(BarAndLineShare, Base)
BarAndLineShare.prototype.init = function () {
    this.option.toolbox = this.getToolbox()
    this.option.grid = this.getGrid()
    this.option.tooltip = this.getTooltip()
    let xaxis = this.getXAxis()
    let x = []
    for (let item of this.xList) {
        x.push(item)
        /* if (isDef(item) && item.indexOf('_') > -1) {
           x.push(item.split('_', -1)[0])
         } else {
           x.push(item)
         }*/
    }
    xaxis[0].data = x
    this.option.xAxis = xaxis
    let yaxiaArr = []
    this.option.series = this.getSeries(yaxiaArr)
    this.option.yAxis = this.getDYAxis(yaxiaArr)
    this.option.legend = this.getLegend(this.option.series)
    let isShowDataZoom = isDef(this.optionSet.isShowDataZoom) ? this.optionSet.isShowDataZoom : false
    if (isShowDataZoom && this.xList.length > defaultNum) {
        this.option.dataZoom = this.getDataZoom()
    }
}
BarAndLineShare.prototype.getTooltip = function () {
    let axisPointerType = isDef(this.optionSet.axisPointerType) ? this.optionSet.axisPointerType : 'shadow'
    let unit = isDef(this.optionSet.unit1) ? this.optionSet.unit1 : '';
    let labelDesp = isDef(this.optionSet.labelDesp) ? this.optionSet.labelDesp : '';
    let isShowLabelDespUnit = isDef(this.optionSet.isShowLabelDespUnit) ? this.optionSet.isShowLabelDespUnit : true;
   // let type = this.type;
    let hiddenData=isDef(this.optionSet.hiddenData)?this.optionSet.hiddenData:[];
    if (isDef(this.type)) {
        return {
            trigger: 'axis', // 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
            confine: true,
            axisPointer: {
                type: axisPointerType
            },
            formatter: function (params) {
                let h = '';
                if (params[0].axisValue.indexOf('_') > -1) {
                    let d = params[0].axisValue.split('_');
                    if (isShowLabelDespUnit) {
                        h = d[0] + '<br />' + labelDesp + d[1] + unit + '<br />';
                    } else {
                        h = d[0] + '<br />' + labelDesp + d[1] + '<br />';
                    }

                } else {
                    h = params[0].axisValue + ' <br />';
                }
                if(hiddenData.length>0){
                    for (let i = 0; i < params.length; i++) {
                        let d = params[i];
                        let u = unit;
                        u = d.seriesType === 'line' ? '%' : unit;
                        let flag=true;
                        for(let it of hiddenData){
                            if(it.name===d.seriesName){
                                flag=false;
                                let da=it.data[d.dataIndex].split('_');
                                h += d.seriesName + ':' + d.value + u +'&nbsp;&nbsp;&nbsp;&nbsp;占比'+da[1]+'%'+'<br />';
                                break;
                            }
                        }
                        if(flag){
                            h += d.seriesName + ':' + d.value + u + '<br />';
                        }
                    }
                }else {
                    for (let i = 0; i < params.length; i++) {
                        let d = params[i];
                        let u = unit;
                        u = d.seriesType === 'line' ? '%' : unit;
                        h += d.seriesName + ':' + d.value + u + '<br />';
                    }
                }

                return h;
            }
        }

    } else {
        return {
            trigger: 'axis', // 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
            confine: true,
            axisPointer: {
                type: axisPointerType
            },
            formatter: function () {
            }
        }
    }
},
    BarAndLineShare.prototype.getSeries = function (yaxiaArr) {
        let alarmColor1 = '#E36042';
        let alarmColor2 = '#EB8750';
        let series = []
        let YAxisMaxVal0 = 100
        let YAxisMaxVal1 = 100
        let YAxisMaxValArr0 = []
        let YAxisMaxValArr1 = []
        let YAxisMinVal0 = 0
        let YAxisMinVal1 = 0
        let YAxisMinValArr0 = []
        let YAxisMinValArr1 = []
        let isShowLineLabel = isDef(this.optionSet.isShowLineLabel) ? this.optionSet.isShowLineLabel : false
        let symbolOffset = isDef(this.optionSet.symbolOffset) ? this.optionSet.symbolOffset : [0, '160%']
        let barWidth = isDef(this.optionSet.barWidth) ? this.optionSet.barWidth : '16';
        let barBorderRadius=isDef(this.optionSet.barBorderRadius) ? this.optionSet.barBorderRadius : 2;
        if (this.yList) {
            for (let item of this.yList) {
                if (isDef(item.isShow) && item.isShow === false) {
                    continue;
                }
                if (item.type == 'line') {
                    YAxisMaxValArr1.push(getObjMaxValue(item.data))
                    YAxisMinValArr1.push(getObjMinValue(item.data))
                } else {
                    YAxisMaxValArr0.push(getObjMaxValue(item.data))
                    YAxisMinValArr0.push(getObjMinValue(item.data))
                }
            }
            YAxisMaxVal0 = getObjMaxValue(YAxisMaxValArr0)
            YAxisMaxVal1 = getObjMaxValue(YAxisMaxValArr1)
            YAxisMinVal0 = getObjMinValue(YAxisMinValArr0)
            YAxisMinVal1 = getObjMinValue(YAxisMinValArr1)
            yaxiaArr[0] = YAxisMinVal0
            yaxiaArr[1] = YAxisMaxVal0
            yaxiaArr[2] = YAxisMinVal1
            yaxiaArr[3] = YAxisMaxVal1
            for (let item of this.yList) {
                if (isDef(item.isShow) && item.isShow === false) {
                    continue;
                }
                if (item.type == 'line') {
                    //YAxisMaxValArr1.push(getObjMaxValue(item.data))
                    //YAxisMinValArr1.push(getObjMinValue(item.data))
                    let data = {
                        type: 'line',
                        yAxisIndex: 1,
                        smooth: true,
                        name: item.name,
                        data: item.data,
                        label: {
                            normal: {
                                show: isShowLineLabel,
                                formatter: function (data) {
                                    let d = Number(data.data);
                                    if (d === 0) {
                                        return d;
                                    } else if (d < 0) {
                                        return '{s|' + d + '}';
                                    } else {
                                        return '{b|' + d + '}';
                                    }
                                },
                                rich: {
                                    s: {
                                        color: '#fff',
                                        fontSize: 10,
                                        backgroundColor: '#FF7878',
                                        borderRadius: 2,
                                        width: 30,
                                        align: 'center',
                                        height: 20
                                    },
                                    b: {
                                        color: '#fff',
                                        fontSize: 10,
                                        backgroundColor: '#3ADC7B',
                                        borderRadius: 2,
                                        width: 30,
                                        align: 'center',
                                        height: 20
                                    }
                                },
                            }
                        }
                    }
                    data.itemStyle = {
                        normal: {
                            color: isDef(item.color) && item.color.length > 0
                                ? new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        {offset: 0, color: item.color[0]},
                                        {offset: 1, color: item.color[1]}
                                    ])
                                : ''
                        }
                    }

                    if (isDef(item.areacolor) && item.areacolor.length >= 2) {
                        data.areaStyle = {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: item.areacolor[0]
                                }, {
                                    offset: 1,
                                    color: item.areacolor[1]
                                }])
                            }
                        }
                    }
                    try {
                        if (isDef(item.markLine) && item.markLine.length >= 2) {
                            let m = item.markLine;
                            let markLine = {
                                silent: true,
                                symbol: "none",
                                label: {
                                    "position": "end",
                                    "formatter": "{b}"
                                },
                                data: [{
                                    "name": m[0],
                                    "yAxis": m[1],
                                    "lineStyle": {
                                        "color": "#FF7533"
                                    },
                                    label: {
                                        "position": "end",
                                        "formatter": "{b} {c}%"
                                    }
                                }]
                            };
                            data.markLine = markLine;
                        }
                    } catch (e) {
                        return '';
                    }


                    series.push(data)
                } else {
                    //YAxisMaxValArr0.push(getObjMaxValue(item.data))
                    //YAxisMinValArr0.push(getObjMinValue(item.data))
                    let reIndexArr = getSortIndex(this.yList);
                   // let markPointId = isDef(this.optionSet.markPointId) ? this.optionSet.markPointId : 1;

                    let markPointArr = getMakePoint(reIndexArr, this.xList, YAxisMinVal0)
                    //alert(JSON.stringify(symbolOffset))


                    let d = {
                        type: 'bar',
                        //id: item.name,
                        name: item.name,
                        barGap: isDef(item.barGap) ? item.barGap : '0%',
                        barWidth: barWidth,
                        stack: isDef(item.stack) ? item.stack : '',
                        data:item.data,
                        markPoint: markPointArr.length > 0 ? {
                           // symbol: 'image://' + require('../../../assets/images/order.png'),
                            symbolSize: 20,
                            symbolOffset: symbolOffset,
                            // symbolOffset: [0, '180%'],
                            data: markPointArr
                        } : {},
                        itemStyle: {

                            normal: {
                                'barBorderRadius':barBorderRadius,
                                //shadowBlur:20,
                                //shadowColor:'yellow',
                                color: function (value) {
                                    if (reIndexArr.length > 0) {
                                        if (reIndexArr.indexOf(Number(value.dataIndex)) > -1) {
                                            return new echarts.graphic.LinearGradient(
                                                0, 0, 0, 1,
                                                [
                                                    {offset: 0, color: alarmColor1},
                                                    {offset: 1, color: alarmColor2}
                                                ])
                                        } else {
                                            return isDef(item.color) && item.color.length > 0
                                                ? new echarts.graphic.LinearGradient(
                                                    0, 0, 0, 1,
                                                    [
                                                        {offset: 0, color: item.color[0]},
                                                        {offset: 1, color: item.color[1]}
                                                    ])
                                                : ''
                                        }

                                    } else {
                                        return isDef(item.color) && item.color.length > 0
                                            ? new echarts.graphic.LinearGradient(
                                                0, 0, 0, 1,
                                                [
                                                    {offset: 0, color: item.color[0]},
                                                    {offset: 1, color: item.color[1]}
                                                ])
                                            : ''
                                    }
                                },
                            }
                        }
                    }

                    series.push(d)
                }
            }

            return series
        } else {
            return series
        }
    }

function getMakePoint(reIndex, xList, yAxis) {
    let re = [];
    if (reIndex.length > 0) {
        for (let i in xList) {
            if (reIndex.indexOf(Number(i)) > -1) {
                re.push({
                    name: xList[i],
                    xAxis: xList[i],
                    yAxis: yAxis
                })
            }
        }

    }
    return re;
}

function getSortIndex(yList) {
    let num = 5;
    let reIndex = [];
    let reData = [];
    let data = [];
    let sortData = [];
    let sortKey = '';
    for (let item of yList) {
        if (item.type === 'line' && isDef(item.isSort)) {
            data = [...item.data];
            sortData = [...item.data];
            sortKey = isDef(item.sortKey) ? item.sortKey : 'up';
            break;
        }
    }
    if (sortData.length > 0) {
        sortData.sort(function (a, b) {
            if (sortKey == 'up') {
                return Number(a) - Number(b)
            } else {
                return Number(b) - Number(a)
            }
        })
        for (let item of sortData) {
            if (sortKey == 'up') {
                if (item < 0 && reData.length < num) {
                    reData.push(item)
                }
            } else {
                if (item > 0 && reData.length < num) {
                    reData.push(item)
                }
            }
        }
        if (reData.length > 0) {
            for (let s of reData) {
                for (let i  in data) {
                    if (data[i] == s) {
                        if (isHasElement(reIndex, i)) {
                            continue
                        } else {
                            reIndex.push(Number(i))
                            break
                        }
                    }
                }
            }
        }

    }
    return reIndex;

}

function isHasElement(indexArr, ele) {
    let flag = false
    for (let item of indexArr) {
        if (item == parseInt(ele)) {
            flag = true
            break
        }
    }
    return flag
}

export default BarAndLineShare
